import styles from "./Modal.module.scss";

interface Props {
	children: React.ReactNode;
}

const MainModal: React.FC<Props> = ({ children }) => {
	return <div className={styles.modal}>{children}</div>;
};

export default MainModal;
